import sanityClient from '@sanity/client'

export default sanityClient({
  projectId: "7mhnvi1z",
  dataset: "production",

})